import * as React from "react";
import {
  SelectInput,
  required,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  TextInput,
  AutocompleteInput,
} from "react-admin";

const ukraineRegions = [
  { id: "Вінницька", name: "Вінницька" },
  { id: "Волинська", name: "Волинська" },
  { id: "Дніпропетровська", name: "Дніпропетровська" },
  { id: "Донецька", name: "Донецька" },
  { id: "Житомирська", name: "Житомирська" },
  { id: "Закарпатська", name: "Закарпатська" },
  { id: "Запорізька", name: "Запорізька" },
  { id: "Івано-Франківська", name: "Івано-Франківська" },
  { id: "Київська", name: "Київська" },
  { id: "Кіровоградська", name: "Кіровоградська" },
  { id: "Луганська", name: "Луганська" },
  { id: "Львівська", name: "Львівська" },
  { id: "Миколаївська", name: "Миколаївська" },
  { id: "Одеська", name: "Одеська" },
  { id: "Полтавська", name: "Полтавська" },
  { id: "Рівненська", name: "Рівненська" },
  { id: "Сумська", name: "Сумська" },
  { id: "Тернопільська", name: "Тернопільська" },
  { id: "Харківська", name: "Харківська" },
  { id: "Херсонська", name: "Херсонська" },
  { id: "Хмельницька", name: "Хмельницька" },
  { id: "Черкаська", name: "Черкаська" },
  { id: "Чернівецька", name: "Чернівецька" },
  { id: "Чернігівська", name: "Чернігівська" },
  { id: "м. Київ", name: "м. Київ" },
];

const EditClient = (merchant_id) => (
  <>
    <TextInput
      source="car_number"
      inputProps={{ maxLength: 12 }}
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
    />
    <AutocompleteInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="region"
      choices={ukraineRegions}
      inputText={(record) => record.name}
      optionText="name"
      optionValue="id"
      debounce={10}
      filterToQuery={(searchText) => ({ name: searchText })}
      alwaysOn
      resettable="true"
    />
    <SelectInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="sex"
      label="resources.Client.fields.sex.name"
      choices={[
        { id: "female", name: "resources.Client.fields.sex.female" },
        {
          id: "male",
          name: "resources.Client.fields.sex.male",
        },
      ]}
      validate={required()}
    />
    <ReferenceInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="category_id"
      reference="Category"
      filter={{
        merchant_id: merchant_id,
      }}
    >
      <SelectInput
        optionText="name"
        optionValue="id"
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
      />
    </ReferenceInput>
    <ReferenceArrayInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="tag_ids"
      reference="Tag"
      filter={{
        merchant_id: merchant_id,
      }}
    >
      <SelectArrayInput optionText="name" optionValue="id" />
    </ReferenceArrayInput>
  </>
);

export default EditClient;
